import EventDetailsModal from './EventDetailsModal';
import { EventDetailsModalProps, EventDetailsModalValueProps } from './types';

export type { EventDetailsModalProps, EventDetailsModalValueProps };
export default EventDetailsModal;
